import { FunctionalComponent, h } from '@stencil/core';

interface AafpHorizontalRuleLinkProps {
  link: HTMLElement;
  firstListItem: boolean;
  url: string;
  [key: string]: any;
}

export const AafpHorizontalRuleLink: FunctionalComponent<AafpHorizontalRuleLinkProps> = ({
  firstListItem,
  link,
  url,
}) => {
  return (
    <div class="adl-horizontal-rule-link">
      {firstListItem && <hr />}
      <div class="adl-horizontal-rule-link__aafp-link" ref={el => el && el.append(link)}>
        <i class="material-icons adl-horizontal-rule-link__arrow" onClick={() => window.location.assign(url)}>
          keyboard_arrow_right
        </i>
      </div>
      <hr />
    </div>
  );
};
